import React, { useEffect, useState } from 'react';
import {
  AbsoluteCenter,
  Spinner,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Tooltip,
  useToast,
  Stack,
  Box,
} from '@chakra-ui/react';
import { EditIcon, AddIcon } from '@chakra-ui/icons';
import Card from 'components/card/Card';
import FaqApi from 'api/faq';
import AddModal from './components/addModal';
import EditModal from './components/editModal';
import { useAuth } from '../../../auth-context/auth.context';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';

export default function Index() {
  const { user } = useAuth();
  const toast = useToast();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [list, setList] = useState([]);
  const [isError, setIsError] = useState('');
  const [listTotal, setListTotal] = useState();
  const [loading, setLoading] = useState(false);
  const { getPermissionsForModule } = usePermissions();
  const [faqPermissions, setfaqPermissions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [fetchListError, setFetchListError] = useState(false);

  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await FaqApi.List({
        currentPage,
        itemsPerPage,
        sort: 'display_order:asc',
      });
      response = response.data;
      setLoading(false);
      console.log(response);
      if (response.status_code === 200) {
        setFetchListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchListError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const faqPermissions = getPermissionsForModule([Modules.Faq]);
    setfaqPermissions(faqPermissions);
  }, [currentPage, getPermissionsForModule]);

  useEffect(() => {
    if (faqPermissions?.read) {
      fetchList();
    }
  }, [currentPage, faqPermissions]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  let totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        colorScheme={i === currentPage ? 'blue' : undefined}
        onClick={() => onPageChange(i)}>
        {i}
      </Button>
    );
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = list.slice(startIndex, endIndex);

  if (!faqPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Faq} />;
  }
  return fetchListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      mt='8rem'
      direction='column'>
      <Flex
        px='25px'
        justify='space-between'
        mb='20px'
        align='center'>
        <Flex ml='auto'>
          <Tooltip
            label={
              !faqPermissions.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren>
            <AddModal
              Icon={<AddIcon />}
              head={'Add FAQ'}
              func={fetchList}
              disabled={!faqPermissions.create}
            />
          </Tooltip>
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Display Order
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Question
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Answer
                </Flex>
              </Th>

              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>

              {/* <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th> */}
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.display_order} ({obj.language_code})
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.question}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.answer}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={obj.is_active ? 'green' : 'red'}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.is_active ? 'ACTIVE' : 'INACTIVE'}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Tooltip
                        label={
                          !faqPermissions.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren>
                        <EditModal
                          Icon={<EditIcon />}
                          head={'Update FAQ'}
                          func={fetchList}
                          currentFaq={obj}
                          disabled={!faqPermissions.update}
                        />
                      </Tooltip>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
